import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('staff_rebate_record')
}

const getters = {
  ...restful.getters('staff_rebate_record')
}

const actions = {
  ...restful.actions('staff_rebate_records')
}

const mutations = {
  ...restful.mutations('staff_rebate_record')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
